


















































































































































































































































































import Vue from 'vue';
import TextInput from '@/components/TextInput.vue';
import InitiativeInput from '@/components/InitiativeInput.vue';
import { mapModelLike } from '@/store/util';
import { mapGetters } from 'vuex';
import { CharacterType } from '@/model';

const AttributesBoxProps = Vue.extend({
  components: { InitiativeInput, TextInput },
  computed: {
    ...mapGetters('attributes', [
      'composure',
      'carryLift',
      'judgeIntentions',
      'memory',
      'iniBase',
      'astralIniBase',
      'astralIniDice',
      'matrixIniDice',
      'matrixIniBase',
    ]),
    ...mapModelLike('attributes', [
      'bod',
      'agi',
      'rea',
      'str',
      'wil',
      'log',
      'int',
      'cha',
      'edg',
      'ess',
      'mag',
      'res',
      'iniDice',
      'movement',
      'currentEdge',
    ]),
  },
});

export default class AttributesBox extends AttributesBoxProps {
  static defaultHeight = 10;

  rules = {
    essence: (value: string) => /^\d([\\.,]\d{1,2})?$/.test(value) || 'Ungültiger Wert',
    notNegative: (value: string) => {
      const parsed = Number.parseInt(value, 10);
      return (Number.isInteger(parsed) && parsed >= 0) || 'Ungültiger Wert';
    },
  }

  get isMage() {
    return this.$store.state.personalData.characterType === CharacterType.awakenedMage;
  }

  get isTechnomancer() {
    return this.$store.state.personalData.characterType === CharacterType.awakenedTechnomancer;
  }
}

